export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/es.7aba0d9b.svg","height":500,"width":750,"blurWidth":0,"blurHeight":0};